<template>
  <main class="w-full flex-grow p-6">
    <button
      @click="showModalEvent"
      class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-sm bg-app-default hover:bg-app-light text-white mb-3 font-bold"
    >
      Apply New
    </button>

    <div class="mt-2 mb-5">
      <table class="w-full mx-auto table-auto">
        <thead class="justify-between">
          <tr class="bg-gray-600">
            <th class="px-5 py-2">
              <span class="text-gray-100 font-semibold">No</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Name</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Avatar</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Option</span>
            </th>
          </tr>
        </thead>
        <tbody class="bg-gray-200">
          <tr
            v-for="(sos, index) in events"
            :key="sos.id"
            :class="[index % 2 !== 0 ? 'bg-gray-200' : '']"
            class="bg-white border-b-2 border-gray-200"
          >
            <td class="px-5 py-2 text-center">
              {{ index + 1 }}
            </td>
            <td class="text-center">
              <span class="font-semibold">
                {{ sos.event_name }}
              </span>
            </td>
            <td class="p-2">
              <div class="flex items-center justify-center">
                <img
                  v-if="sos.event_images.length"
                  class="w-10 h-10 cursor-pointer"
                  @click="showModal(sos.event_images)"
                  :src="sos.event_images"
                  alt="23paskal"
                />
              </div>
            </td>
            <td class="">
              <div class="flex items-center justify-evenly">
                <button
                  class=""
                  type="button"
                  @click="detailPremiumEvent(sos.id_event)"
                >
                  <span class="font-bold text-app-default">
                    More
                  </span>
                </button>
                <button
                  class=""
                  type="button"
                  @click="deletePremiumEvent(sos.id)"
                >
                  <fas icon="trash-alt" class="text-red-600 text-xl" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal Add -->
    <div
      v-if="modalpromotion"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full h-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden h-full"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">
              Apply To Premium Event
            </div>
            <div class="">
              <button
                @click.self="showModalEvent"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex flex-col">
            <div class="w-full lg:w-1/4 pr-0 lg:pr-2">
              <input
                v-model="table.search"
                @keyup="searchPremiumEvent"
                type="text"
                class="w-full h-9 px-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200 mb-5"
                placeholder="Search name"
              />
            </div>
            <div class="mt-2 mb-5">
              <div
                v-for="sos in not_premium_event"
                :key="sos.id"
                class="border-b-2 flex items-center justify-between mb-2 pb-2"
              >
                <div class="flex items-center">
                  <div class="mr-5">
                    <img
                      v-if="sos.event_images.length"
                      class="w-10 h-10"
                      :src="sos.event_images[0]"
                      alt="23paskal"
                    />
                  </div>
                  <div class="">
                    {{ sos.event_name }}
                  </div>
                </div>
                <div class="mr-10">
                  <button
                    class=""
                    type="button"
                    @click="applyPremiumEvent(sos.id)"
                  >
                    <span class="font-bold text-app-default">
                      Apply
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalEvent"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <Warning />
    <Modal v-show="isModalVisible" @close="closeModal" :imageso="imageso" />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import Warning from "../../components/Warning.vue";
import Modal from "../../components/Modal.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "Event",
  components: {
    Warning,
    Modal,
    SuccessNotif,
  },
  data() {
    return {
      imageso: "",
      isModalVisible: false,
      modalpromotion: false,
      events: [],
      not_premium_event: [],
      table: {
        current_page: 1,
        per_page: 6,
        search: "",
        total: 0,
      },
    };
  },
  methods: {
    showModal: function(data) {
      this.imageso = data;
      this.isModalVisible = true;
    },
    closeModal: function() {
      this.isModalVisible = false;
    },
    searchPremiumEvent: function() {
      this.current_page = 1;
      this.per_page = 6;
      this.findNotPremiumEvent();
    },
    detailPremiumEvent: function(id) {
      this.$router.push({ path: `/event/${id}` });
    },
    showModalEvent: function() {
      this.modalpromotion = !this.modalpromotion;
    },
    findEventPremium: async function() {
      try {
        let res = await fetch(`${API}v1/event-info`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.events = respon.data.event;
      } catch (err) {
        this._error("internal server error");
      }
    },
    findNotPremiumEvent: async function() {
      try {
        let res = await fetch(
          `${API}v1/admin/cms/event/premium?current_page=${this.table.current_page}&per_page=${this.table.per_page}&search=${this.table.search}&not_premium=true`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        //console.log("not", respon.data.events);
        this.not_premium_event = respon.data.events;
        this.table.current_page = respon.data.current_page;
        this.table.per_page = respon.data.per_page;
        this.table.search = respon.data.search ?? "";
        this.table.total = respon.data.total;
      } catch (err) {
        this._error("internal server error");
      }
    },
    deletePremiumEvent: async function(id) {
      try {
        let res = await fetch(`${API}v1/admin/cms/event/premium/delete`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: id,
          }),
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.findEventPremium();
        this.findNotPremiumEvent();
        this._success("Data deleted.");
      } catch (err) {
        this._error("internal server error");
      }
    },
    applyPremiumEvent: async function(id) {
      try {
        let res = await fetch(`${API}v1/admin/cms/event/premium/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            event_id: id,
          }),
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this.modalpromotion = false;
          this._error(respon.message);
          return;
        }
        this.modalpromotion = false;
        this.findEventPremium();
        this.findNotPremiumEvent();
        this._success("Data updated.");
      } catch (err) {
        this.modalpromotion = false;
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", false);
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created: function() {
    this.findNotPremiumEvent();
    this.findEventPremium();
  },
};
</script>
